import React, { useState, useEffect } from 'react';
import AddProduct from './addProduct';
import { addProductCart } from '../../../middleware/cartFunctions';
import { formatNumber } from '../../../middleware/common-functions';
import no_img from '../../../assets/no_image.jpg';

const NeddedProduct = ({ product, product_amount = 1, type, updateCart }) => {
  const [amount, setAmount] = useState(product_amount);
  const [added, setAdded] = useState(false);
  useEffect(() => {
    setAmount(product_amount);
  }, [product_amount]);

  const promtAddProduct = async (ev) => {
    const product_amount = document.getElementById(
      `cant_input_related_${product.id}`
    ).value;
    await addProductCart({
      product_amount: product_amount,
      product_id: product.id,
      product_data: product,
    });
    updateCart();
    setAdded(true);
    setTimeout(() => {
      setAdded(false);
    }, 5500);
  };

  return (
    <div className="related-product-container">
      <div className="related-product-item">
        <div className="related-product-image">
          <a href={`/product/${product.id}`}>
            <img
              src={
                product.images && product.images.length > 0
                  ? product.images[0]
                  : no_img
              }
              alt={product.descp1}
              className="img-fluid"
            />
          </a>
        </div>

        <div className="related-product-details">
          <div className="related-product-title">
            <a href={`/product/${product.id}`}>{product.descp1}</a>
          </div>

          {type === 'needed' && (
            <div className="related-product-suggestion">
              <i className="fas fa-info-circle mr-1"></i>
              Cantidad sugerida: {product_amount}
            </div>
          )}

          <div className="related-product-price">
            <span className="price-label">Precio:</span>
            <span className="price-value">${product.price}</span>
          </div>

          {amount && (
            <div className="related-product-total">
              <span className="total-label">Total:</span>
              <span className="total-value">
                ${formatNumber(product.price_num * amount, true)}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="related-product-actions">
        <AddProduct
          promptAdd={promtAddProduct}
          added={added}
          cant_hidd
          product_id={product.id}
          from="related"
          unit={product.xium ? product.xium.descrp : 'pz'}
          block
          suggest_amount={product_amount}
        />
      </div>
    </div>
  );
};

export default NeddedProduct;
